var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 64,
    viewBox: "0 0 149 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2082_3594",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 12,
    width: 22,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6172 12L32.2301 12V26.2183L11.6172 26.2183L11.6172 12Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2082_3594)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2082_3594",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 21,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0859 20.0582C13.3962 21.954 14.4283 23.946 15.0835 26.1232C16.4889 22.9019 19.0179 20.247 22.1106 18.7326C25.2984 20.247 27.7323 22.9019 29.1377 26.1232C29.7929 23.946 30.825 21.8577 32.1352 20.0582C29.7014 16.6443 26.1402 14.0858 22.0191 12.6639C18.081 14.0858 14.615 16.6443 12.0859 20.0582Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2082_3594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0859 26.1232L32.1352 26.1232V12.6639L12.0859 12.6639L12.0859 26.1232Z",
    fill: "url(#paint0_linear_2082_3594)"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.186657 44.7039C0.373316 43.3784 0.373316 42.0491 0.186657 40.8161C2.43388 42.9044 7.58711 43.9449 11.9901 43.9449C15.5512 43.9449 17.0518 43.1858 17.0518 41.5752C17.0518 39.4906 14.8009 39.3017 9.46101 38.8278C3.55749 38.3538 0 37.4059 0 33.8032C0 30.2005 3.18417 28.5898 9.74283 28.5898C13.3955 28.5898 16.9566 29.0638 20.4226 30.0117C20.236 31.2447 20.236 32.4777 20.4226 33.707C16.9566 32.2851 13.304 31.4335 9.55617 31.4335C5.80837 31.4335 4.30778 32.1926 4.30778 33.707C4.30778 35.6027 6.27684 36.0767 11.1483 36.4581C17.3336 36.932 21.3596 37.7836 21.3596 41.5752C21.3596 45.0816 18.0802 46.696 11.6167 46.696C7.68227 46.696 3.8393 46.0295 0.186657 44.7039Z",
    fill: "#004433"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.764 32.1899C28.6688 36.9293 28.764 41.765 28.9507 46.5045H24.7344C24.921 40.6246 24.921 34.7484 24.7344 28.9648C26.7034 29.1574 28.6688 29.1574 30.6379 28.9648C34.3857 33.8006 38.225 38.6363 42.2546 43.3757C42.3498 38.54 42.2546 33.708 42.068 28.9648C43.4734 29.1574 44.974 29.1574 46.3794 28.9648C46.1891 34.8447 46.1891 40.7209 46.4709 46.5045H40.6626C36.8196 41.5725 32.8851 36.8331 28.764 32.1899Z",
    fill: "#004433"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8114 43.755C56.7768 43.8512 58.1823 43.8512 61.1798 43.8512C65.4912 43.8512 66.6148 42.6182 66.6148 41.1964C66.6148 39.7746 65.4912 38.9192 61.3701 38.9192H54.7163C54.7163 40.5336 54.7163 42.2369 54.8114 43.755ZM61.3701 36.6458C64.2725 36.6458 65.773 35.7942 65.773 34.0872C65.773 32.3803 64.181 31.6213 61.3701 31.6213H54.7163C54.7163 33.1394 54.6211 34.8463 54.7163 36.6458C56.7768 36.5495 59.0277 36.6458 61.3701 36.6458ZM50.5 28.8739C53.7793 28.8739 56.7768 28.7776 61.3701 28.7776C66.9918 28.7776 70.0808 30.1069 70.0808 33.1394C70.0808 35.8867 67.5518 37.0235 64.4591 37.1197V37.4048C68.3021 37.4974 71.2081 38.7304 71.2081 41.7629C71.2081 46.0284 65.3046 46.5023 60.9931 46.5023C55.9351 46.5023 53.7793 46.4098 50.5 46.4098C50.7818 42.048 50.7818 33.2319 50.5 28.8739Z",
    fill: "#004433"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1632 49.3496C87.7899 49.3496 87.4129 49.4422 87.1311 49.7273C86.853 49.9161 86.7578 50.2975 86.7578 50.6752C86.7578 51.0528 86.853 51.4305 87.1311 51.6231C87.4129 51.9045 87.7899 52.0007 88.1632 52.0007C88.5366 52.0007 88.9135 51.9045 89.1002 51.6231C89.382 51.338 89.5687 51.0528 89.4735 50.6752C89.4735 50.2975 89.2868 50.0087 89.1002 49.7273C88.9135 49.4422 88.5366 49.3496 88.1632 49.3496Z",
    fill: "#004433"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4171 49.3496C84.0438 49.3496 83.6669 49.4422 83.385 49.7273C83.1069 49.9161 83.0117 50.2975 83.0117 50.6752C83.0117 51.0528 83.1069 51.4305 83.385 51.6231C83.6669 51.9045 84.0438 52.0007 84.4171 52.0007C84.7905 52.0007 85.1674 51.9045 85.3541 51.6231C85.6359 51.338 85.7274 51.0528 85.7274 50.6752C85.7274 50.2975 85.6359 50.0087 85.3541 49.7273C85.0723 49.4422 84.699 49.3496 84.4171 49.3496Z",
    fill: "#004433"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.148 38.7296V44.5131H117.306C114.495 44.5131 113.837 42.5211 113.837 41.7621C113.745 40.0551 115.242 38.2556 118.148 38.7296ZM123.675 33.3273C122.082 32.0943 120.117 31.5278 118.148 31.6204C113.463 31.6204 111.963 34.2752 111.685 34.8417L113.65 35.6971C114.682 34.2752 116.274 33.5162 117.961 33.705C122.459 33.705 123.019 36.6449 123.019 38.1593V43.1839C123.019 44.0392 122.269 44.702 121.427 44.6057H120.49V37.5928C119.458 37.1189 118.335 36.8338 117.306 36.8338C114.118 36.8338 111.589 38.1593 111.589 41.9509C111.589 42.8988 111.963 43.8467 112.526 44.6057L107 44.6057V27.4512L104.467 28.3991V42.3323C104.467 43.5653 103.999 44.5131 101.565 44.5131H98.6587C98.2854 44.5131 97.8169 44.5131 96.9714 43.1839L91.2582 33.1385L90.3213 31.5278C88.0704 32.8534 86.5735 35.2231 86.3868 37.7817C86.4783 39.2035 86.9468 40.5291 87.6971 41.6695L89.6662 44.5131H82.262C80.2966 44.5131 79.3597 43.469 79.3597 41.1955C79.4512 39.8663 79.8282 38.5407 80.67 37.4966L79.1694 36.5487C78.0458 37.9705 77.3906 39.7737 77.3906 41.6695C77.3906 44.6057 79.1694 46.4089 82.4487 46.4089H93.5055L90.1346 41.4769C88.8207 39.3923 87.8838 37.4966 89.6662 35.0343C90.6031 36.6449 95.006 44.228 95.2879 44.6057C96.0345 45.8387 97.3484 46.5015 98.7539 46.4089H101.751C102.315 46.4089 102.875 46.4089 103.439 46.2164C103.812 46.1238 104.189 46.0275 104.562 45.8387V46.3127L122.269 46.3127C124.052 46.4089 125.644 44.9871 125.739 43.1839V37.9705C125.739 36.3598 124.988 34.5603 123.675 33.3273Z",
    fill: "#004433"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.547 31.6192L136.327 29.8197V28.5867L133.984 29.4383L133.703 28.7756C133.607 28.4904 133.703 28.209 134.076 28.0165C134.171 27.9239 134.358 27.9239 134.544 27.9239C134.731 27.9239 134.826 28.0165 134.921 28.1128L135.2 28.3016L135.481 27.2612L135.295 27.1649C134.731 26.7872 133.984 26.6909 133.326 26.976C132.857 27.1649 132.389 27.45 132.202 27.9239C132.015 28.3979 132.015 28.8718 132.297 29.3458L132.579 30.0085L132.111 30.1974L131.547 31.6192Z",
    fill: "#004433"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M139.604 42.5211C139.513 43.7541 138.484 44.702 137.262 44.6057H135.673V31.3353L133.141 32.2832V44.6057H129.861L129.02 46.5015H137.639C139.513 46.5015 142.042 44.8908 142.042 42.3323V27.4512L139.513 28.3991V42.5211H139.604Z",
    fill: "#004433"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M146.352 28.4903V46.4076H148.789V27.6387L146.352 28.4903Z",
    fill: "#004433"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2082_3594",
    x1: 22.1113,
    y1: 26.1247,
    x2: 22.1113,
    y2: 12.6647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82C341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#82C341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117188,
    stopColor: "#81C241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#80C241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195313,
    stopColor: "#80C241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#7FC141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#7FC141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#7EC142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351563,
    stopColor: "#7EC042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#7DC042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429688,
    stopColor: "#7DC042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#7CBF42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507813,
    stopColor: "#7CBF42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#7BBF42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#7BBE42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#7ABE42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664063,
    stopColor: "#7ABE42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#79BD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#79BD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#78BD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820313,
    stopColor: "#78BC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#77BC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898438,
    stopColor: "#77BC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#76BB43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976563,
    stopColor: "#75BB43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#75BB43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#74BA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#74BA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#73BA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#73B943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#72B943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#72B943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#71B843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    stopColor: "#71B843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#70B844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#70B744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#6FB744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#6FB744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#6EB644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#6EB644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#6DB644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#6DB544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#6CB544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#6CB544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#6BB544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#6BB444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#6AB444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#6AB445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#69B345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    stopColor: "#69B345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#68B345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#68B245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#67B245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#67B245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#66B145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#66B145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#65B145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#65B045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#64B045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#64B045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#63AF46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#63AF46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#62AF46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#62AE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#61AE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257813,
    stopColor: "#61AE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#60AD46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#60AD46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#5FAD46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#5FAC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#5EAC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#5EAC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#5DAB46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#5DAB46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#5CAB47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#5CAA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#5BAA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#5BAA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#5AA947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#5AA947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#59A947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#58A947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#58A847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#57A847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#57A847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#56A747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#56A747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#55A748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#55A648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#54A648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#54A648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#53A548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#53A548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#52A548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#52A448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#51A448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#51A448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#50A348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#50A348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#4FA348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#4FA248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#4EA249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#4EA249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#4DA149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#4DA149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#4CA149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#4CA049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#4BA049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#4BA049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#4A9F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#4A9F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#499F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#499E49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#489E49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#489E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#479D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#479D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#469D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#469C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#459C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#459C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#449C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#449B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#439B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#439B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#429A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#429A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#419A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#41994B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#40994B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#40994B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#3F984B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#3F984B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#3E984B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#3E974B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#3D974B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#3D974B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#3C964B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#3C964B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#3B964B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#3A954B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#3A954C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#39954C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#39944C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#38944C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    stopColor: "#38944C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#37934C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#37934C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#36934C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#36924C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#35924C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#35924C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#34914C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#34914C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#33914C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#33904D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#32904D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#32904D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#318F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#318F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#308F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632813,
    stopColor: "#308F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#2F8E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#2F8E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#2E8E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#2E8D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#2D8D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#2D8D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#2C8C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664063,
    stopColor: "#2C8C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#2B8C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#2B8B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#2A8B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#2A8B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#298A4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#298A4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#288A4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#28894E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#27894E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#27894E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#26884E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#26884E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#25884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#25874F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#24874F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#24874F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#23864F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#23864F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#22864F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#22854F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#21854F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#21854F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#20844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#20844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#1F844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#1F8350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#1E8350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#1D8350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#1D8250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#1C8250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#1C8250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#1B8250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#1B8150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#1A8150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#1A8150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#198050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#198050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#188050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#187F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#177F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#177F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#167E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#167E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#157E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#157D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#147D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#147D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851563,
    stopColor: "#137C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#137C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#127C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#127B51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#117B51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871094,
    stopColor: "#117B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#107A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#107A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882813,
    stopColor: "#0F7A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886719,
    stopColor: "#0F7952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#0E7952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#0E7952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#0D7852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#0D7852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#0C7852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#0C7752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914063,
    stopColor: "#0B7752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#0B7752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#0A7653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925781,
    stopColor: "#0A7653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#097653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933594,
    stopColor: "#097653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#087553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941406,
    stopColor: "#087553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945313,
    stopColor: "#077553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949219,
    stopColor: "#077453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#067453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957031,
    stopColor: "#067453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#057353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964844,
    stopColor: "#057353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#047353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972656,
    stopColor: "#047253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976563,
    stopColor: "#037254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980469,
    stopColor: "#037254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#027154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988281,
    stopColor: "#027154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#017154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996094,
    stopColor: "#007054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007054"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnbLogo);
export default __webpack_public_path__ + "static/media/snb_logo.47c409ea3208d1f3765649da1fb5979a.svg";
export { ForwardRef as ReactComponent };